import { render } from "./AssignDogDialog.vue?vue&type=template&id=b1392ab4"
import script from "./AssignDogDialog.vue?vue&type=script&lang=js"
export * from "./AssignDogDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__